import type { WebPaymentMethodSelection } from "./webPaymentMethodSelection"

export const PLAID_OAUTH_RESUME_FLAG = "plaid-oauth-resume"

export type PlaidOAuthResumeFlow = "SignUpFlow" | "CharityFlow"

/** What fallback Plaid Link needs to be re-opened after an OAuth bank redirect. */
export type PlaidOAuthResumePlaidState = {
  linkToken: string
  tokenId: string
  verificationId: string
  signUpPhoneNumber: string | null
}

export type PlaidOAuthResumeCharityState = {
  amount: string
  isRecurring: boolean
  payerCoversFee: boolean
}

export type PlaidOAuthResumeRecord = PlaidOAuthResumePlaidState & {
  version: 1
  savedAt: number
  flow: PlaidOAuthResumeFlow
  flowParams?: Record<string, unknown>
  /** `actor.getPersistedSnapshot()` of the flow machine when Link opened. */
  flowSnapshot: unknown
  paymentSelection?: WebPaymentMethodSelection
  charity?: PlaidOAuthResumeCharityState
}

export type PlaidOAuthResumeInput = Omit<PlaidOAuthResumeRecord, "version" | "savedAt">

export type PlaidProviderOAuthResume = {
  /** Set when this page load is the bank's OAuth return and a saved flow matched. */
  restored: PlaidOAuthResumePlaidState | null
  receivedRedirectUri: string | null
  onBeforeOpen: (plaid: PlaidOAuthResumePlaidState) => void
}
